import { Text } from "@/components/ui/text";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { Dictionary } from "../../../dictionaries";

const mobileProviders = [
  {
    name: "Airtel Money",
    logo: "/mnos/airtel-seeklogo.png",
    fallback: "AM",
    className: "size-8",
  },
  {
    name: "M-Pesa",
    logo: "/mnos/vodacom-seeklogo.png",
    fallback: "MP",
    className: "w-11",
  },
  {
    name: "Halopesa",
    logo: "/mnos/halopesa.png",
    fallback: "HP",
    className: "size-8",
  },
  {
    name: "Mixx",
    logo: "/mnos/mixx-by-yas-seeklogo.png",
    fallback: "MX",
    className: "w-11",
  },
  {
    name: "TANQR Payment",
    logo: "/mnos/tips.png",
    fallback: "QR",
    className: "h-8 w-16",
  },
];

const cardProviders = [
  {
    name: "Visa",
    logo: "/card/Visa.png",
    fallback: "VI",
    className: "h-8 w-11",
  },
  {
    name: "Mastercard",
    logo: "/card/Mastercard.png",
    fallback: "MC",
    className: "h-8 w-11",
  },
  {
    name: "Amex",
    logo: "/card/Amex.png",
    fallback: "AX",
    className: "h-8 w-11",
  },
];

interface SupportedProvidersProps {
  dictionary: Dictionary;
}

export function SupportedProviders({ dictionary }: SupportedProvidersProps) {
  return (
    <div className="flex flex-col items-center gap-2">
      <Text variant="muted" className="text-xs py-2">
        {dictionary.checkout.supportedProviders}
      </Text>
      <div className="flex flex-wrap items-center justify-center gap-1.5">
        {mobileProviders.map((provider) => (
          <Avatar
            key={provider.name}
            className={`rounded-none p-1 ${provider.className}`}
          >
            <AvatarImage src={provider.logo} alt={provider.name} />
            <AvatarFallback>{provider.fallback}</AvatarFallback>
          </Avatar>
        ))}
      </div>
      <div className="flex flex-wrap items-center justify-center gap-1.5">
        {cardProviders.map((provider) => (
          <Avatar
            key={provider.name}
            className={`rounded-none p-1 ${provider.className}`}
          >
            <AvatarImage src={provider.logo} alt={provider.name} />
            <AvatarFallback>{provider.fallback}</AvatarFallback>
          </Avatar>
        ))}
      </div>
    </div>
  );
}
